import script from "./dict.vue?vue&type=script&setup=true&lang=js"
export * from "./dict.vue?vue&type=script&setup=true&lang=js"

import "./dict.vue?vue&type=style&index=0&id=2f212542&lang=css&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2f212542"]])

export default __exports__